export enum ContactPolicyActionStatus {
  CLICKED = 'clicked',
  CREATED = 'created',
  DISPATCHED = 'dispatched',
  FEEDBACK_SUBMITTED = 'feedback_submitted',
  OPENED = 'opened',
  SENT = 'sent',
}
